import { apiDelete, apiGet, apiPost } from '../client';
import {
  NotificationDestinationResponseSchema,
  NotificationVerificationStartResponseSchema,
  type NotificationDestinationResponse,
  type NotificationVerificationStartResponse,
} from '../schemas';

const DESTINATION_PATH = '/v1/business/notification-destination';

export type StartNotificationVerificationInput = {
  channel: 'whatsapp';
  phone: string;
};

export function getNotificationDestination(): Promise<NotificationDestinationResponse> {
  return apiGet(DESTINATION_PATH, NotificationDestinationResponseSchema);
}

export function startNotificationVerification(
  input: StartNotificationVerificationInput,
  idempotencyKey: string,
): Promise<NotificationVerificationStartResponse> {
  return apiPost(
    `${DESTINATION_PATH}/verification/start`,
    NotificationVerificationStartResponseSchema,
    input,
    idempotencyKey,
  );
}

export function confirmNotificationVerification(
  input: { challengeId: string; code: string },
  idempotencyKey: string,
): Promise<NotificationDestinationResponse> {
  return apiPost(
    `${DESTINATION_PATH}/verification/confirm`,
    NotificationDestinationResponseSchema,
    input,
    idempotencyKey,
  );
}

export function disableNotificationDestination(
  idempotencyKey: string,
): Promise<NotificationDestinationResponse> {
  return apiDelete(DESTINATION_PATH, NotificationDestinationResponseSchema, idempotencyKey);
}
